const distanceUnitMapper = {
  km: "kilometer",
  m: "meter",
  cm: "centimeter",
  mm: "millimeter",
  mi: "mile",
  yd: "yard",
  ft: "foot",
  in: "inch"
};
export {
  distanceUnitMapper
};
